import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
} from "components/ui/dialog";

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "components/ui/alert-dialog";

import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
} from "components/ui/drawer";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "components/ui/select";

import { Label } from "components/ui/label";
import { Input } from "components/ui/input";

import { fetchAxiosToken } from "helpers/fetchAxiosToken";
import { toast } from "components/ui/use-toast";

import { Switch } from "components/ui/switch";

import { ScrollArea } from "components/ui/scroll-area";
import { Separator } from "components/ui/separator";
import dayjs from "dayjs";
import { useAppSelector } from "hooks/hooks";
import { Button } from "components/ui/button";
import { ReloadIcon } from "@radix-ui/react-icons";
import DinamicSearchBar from "./DinamicSearchBar";
import { fetchAxiosNoToken } from "helpers/fetchAxiosNoToken";
import { Casa } from "../CasasBroker";
import { number } from "yargs";

interface Props {
    setEdit: (visible: Date | null) => void;
    edit: Date;
    getEvents: () => void;
}
interface User {
    name: string;
    last_name: string;
    specialty: string;
}

interface input {
    query: string;
    enabled: boolean;
    page: number;
    limit: number;
}

interface patients {
    total: number;
    loading: boolean;
    patient: patient[];
}

interface patient {
    id: number;
    nombre: string;
    apellido: string;
    correo: string;
    celular: string;
    avatar: string;
    tipo_contacto: string;
    fecha_ultima_reserva: string;
    id_pedido: number;
    id_crm: number;
    etapa_crm: string;
}

interface SelectedFile {
    img: File | null;
    type: string;
}

const INITIAL_STATE = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    rol: "customer",
};

export interface Intervals {
    closing_time: string;
    opening_time: string;
}

export const ShiftNewCalendarModal = ({ setEdit, edit, getEvents }: Props) => {
    const [idOffice, setIdOffice] = useState<string>("");
    const [select, setSelect] = useState<null | string>(null);
    const [deleteShift, setDeleteShift] = useState(false);
    const [step, setStep] = useState(0);
    const [avatar, setAvatar] = useState<string>("");
    const [newPatient, setNewPatient] = useState(INITIAL_STATE);
    const [selectedFile, setSelectedFile] = useState<SelectedFile>({
        img: null,
        type: "",
    });
    const [intervals, setIntervals] = useState<Intervals[]>([]);
    const [startTime, setStartTime] = useState<string>("");
    const [endTime, setEndTime] = useState<string>("");
    const [timeOfTurn, setTimeOfTurn] = useState<string>("");
    const [casaSelected, setCasaSelected] = useState<number | null>(null);
    const [recurrenceType, setRecurrenceType] = useState<string>("");
    const [endDate, setEndDate] = useState("");
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingPatient, setLoadingPatient] = useState<boolean>(false);
    const [toggleButton, setToggleButton] = useState(false);
    const [input, setInput] = useState<input>({
        query: "",
        enabled: true,
        page: 1,
        limit: 15,
    });
    const [casas, setCasas] = useState<Casa[]>([]);

    const { id } = useAppSelector((state) => state.usuario_logeado);

    const [patients, setPatients] = useState<patients>({
        total: 0,
        loading: false,
        patient: [],
    });

    const [patientSelected, setPatientSelected] = useState<patient | null>(
        null
    );

    const getAllCasas = async () => {
        setLoading(true);

        fetchAxiosNoToken({
            url: `/corredor/getAllCasas/${id}?query=Completo`,
        })
            .then((res) => {
                console.log(res);
                setCasas(res);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const handleAvatarClick = async (avatarUrl: string) => {
        const fileName = avatarUrl.substring(avatarUrl.lastIndexOf("/") + 1);

        fetch(avatarUrl)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], fileName, {
                    type: "image/jpeg",
                });

                setSelectedFile({ img: file, type: "avatar" });
                setAvatar(URL.createObjectURL(file));
            })
            .catch((error) => console.error("Error fetching avatar:", error));
    };

    const handleChangeImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            return;
        }
        setSelectedFile({ img: e.target.files[0], type: "profile" });
        setAvatar(URL.createObjectURL(e.target.files[0]));

        const cancelButton: HTMLElement | null =
            document.querySelector(".cancel-button");
        if (cancelButton) {
            cancelButton.click();
        }
    };

    const handleSubmit = async () => {
        if (edit === null) {
            return;
        }

        if (step === 2 && select === "bloquear") {
            try {
                setLoading(true);
                await fetchAxiosToken({
                    url: `/horarios_no_disponibles/crearHorarioNoDisponible/`,
                    method: "post",
                    body: {
                        tipo_tiempo: "allday",
                        tipo_horas: "fordates",
                        fecha_inicio: edit.toISOString().split("T")[0],
                        fecha_final: edit.toISOString().split("T")[0],
                        hora_inicio: "00:00",
                        hora_final: "00:00",
                        id_corredor: id,
                    },
                });
                setLoading(false);
                toast({
                    title: "Dia bloqueado correctamente",
                });
                await getEvents();
                setTimeout(() => {
                    setLoading(false);
                }, 2000);

                setEdit(null);
                return;
            } catch (error: any) {
                toast({
                    variant: "destructive",
                    title: "Error",
                    description: <div>{error.response.data?.message}</div>,
                });
                setLoading(false);
            }
        } else if (step === 3 && select === "bloquear") {
            if (startTime === "" || endTime === "") {
                toast({
                    variant: "destructive",
                    title: "Error",
                    description: "Seleccione la hora de inicio y fin",
                });
                return;
            }

            if (
                dayjs(
                    `${edit.toISOString().split("T")[0]} ${startTime}`,
                    "YYYY-MM-DD HH:mm"
                ).isAfter(
                    dayjs(
                        `${edit.toISOString().split("T")[0]} ${endTime}`,
                        "YYYY-MM-DD HH:mm"
                    )
                )
            ) {
                toast({
                    variant: "destructive",
                    title: "Error",
                    description:
                        "La hora de inicio no puede ser mayor a la de fin",
                });
                return;
            }

            try {
                setLoading(true);
                await fetchAxiosToken({
                    url: `/horarios_no_disponibles/crearHorarioNoDisponible/`,
                    method: "post",
                    body: {
                        tipo_tiempo: "forhours",
                        tipo_horas: "fordates",
                        fecha_inicio: edit.toISOString().split("T")[0],
                        fecha_final: edit.toISOString().split("T")[0],
                        hora_inicio: startTime,
                        hora_final: endTime,
                        id_corredor: id,
                    },
                });
                setLoading(false);
                toast({
                    title: "Hora bloqueada correctamente",
                });
                await getEvents();
                setTimeout(() => {
                    setLoading(false);
                }, 2000);

                setEdit(null);
                return;
            } catch (error: any) {
                toast({
                    variant: "destructive",
                    title: "Error",
                    description: <div>{error.response.data?.message}</div>,
                });
                setLoading(false);
            }
        } else if (patientSelected && select === "agendar") {
            if (timeOfTurn === "") {
                toast({
                    variant: "destructive",
                    title: "Error",
                    description: "Seleccione la hora del turno",
                });
                return;
            }
            if (casaSelected === null) {
                toast({
                    variant: "destructive",
                    title: "Error",
                    description: "Seleccione una propiedad",
                });
                return;
            }
            const time = intervals.find(
                (interval) => interval.opening_time === timeOfTurn
            );
            if (!time) {
                toast({
                    variant: "destructive",
                    title: "Error",
                    description: "Seleccione una hora valida",
                });
                return;
            }
            try {
                setLoading(true);
                await fetchAxiosToken({
                    url: `/visitas_agendadas/createVisitaAgendada`,
                    method: "post",
                    body: {
                        estado: "Agendado",
                        scheduled_by: "Propietario",
                        id_cliente: patientSelected.id,
                        id_casa: casaSelected,
                        fecha: edit.toISOString().split("T")[0],
                        nota: "agenda por corredor",
                        hora_inicio: time?.opening_time,
                        hora_final: time?.closing_time,
                    },
                });
                setLoading(false);
                toast({
                    title: "Turno agendado correctamente",
                });
                await getEvents();
                setTimeout(() => {
                    setLoading(false);
                }, 2000);

                setEdit(null);
                return;
            } catch (error: any) {
                console.log(error, "error");
                toast({
                    variant: "destructive",
                    title: "Error",
                    description: <div>{error.response.message}</div>,
                });
                setLoading(false);
            }
        }
    };

    const handleSubmitPatient = async () => {
        const newErrors: Partial<any> = {};
        if (!newPatient.firstName) {
            newErrors.firstName = "Ingrese un nombre valido";
        }
        if (!newPatient.lastName) {
            newErrors.lastName = "Ingrese un apellido valido";
        }

        if (!newPatient.phone) {
            newErrors.phone = "Ingrese un numero de celular";
        }

        if (newPatient.email && !validateEmail(newPatient.email)) {
            newErrors.email = "Ingrese un email valido";
        }

        if (Object.keys(newErrors).length > 0) {
            const errorList = Object.values(newErrors).map((error) => (
                <div key={error}>- {error}</div>
            ));
            toast({
                variant: "destructive",
                title: "Verifica los siguientes datos:",
                description: <div className="">{errorList}</div>,
            });
            // setErrors(newErrors);
            return;
        }

        try {
            setLoadingPatient(true);

            const data = await fetchAxiosToken({
                url: `/clientes/postContact`,
                method: "post",
                body: {
                    nombre: newPatient.firstName.trim(),
                    apellido: newPatient.lastName.trim(),
                    correo: newPatient.email.trim(),
                    celular: newPatient.phone.trim(),
                },
            });
            setLoadingPatient(false);
            toast({
                title: "Contacto guardado correctamente",
            });
            console.log("data nuevo contacto", data);
            const patientCreated: patient = data.usuario || null;
            setPatientSelected(patientCreated);
            setDeleteShift(false);
            setNewPatient(INITIAL_STATE);
            setSelectedFile({
                img: null,
                type: "",
            });

            setAvatar("");
            const cancelButton: HTMLElement | null =
                document.querySelector(".cancel-button");
            if (cancelButton) {
                cancelButton.click();
            }
        } catch (error: any) {
            console.log(error);
            toast({
                variant: "destructive",
                title: "Error al registrar",
                description: `${error.response.data?.message}`,
            });
            setLoadingPatient(false);
            return;
        }
    };
    const validateEmail = (email: string): boolean => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const getData = async () => {
        setPatients({ ...patients, loading: true });

        window.scrollTo(0, 0);
        try {
            const data = await fetchAxiosToken({
                url: `/clientes/getContacts/${id}?cliente=${input.query}`,
                method: "get",
                body: input,
            });
            console.log("pacientest", data);

            setPatients({
                ...patients,
                patient: data,
                total: 3,
                loading: false,
            });
        } catch (error) {
            console.log(error);
        }
    };
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setNewPatient({
            ...newPatient,
            [e.target.name]: e.target.value,
        });
    };

    const getOffices = async () => {
        try {
            const dataInterval = await fetchAxiosToken({
                url: `/horarios_asesores/getIntervals/${id}`,
                body: {
                    date: dayjs(edit).format("YYYY-MM-DD"),
                },
                method: "post",
            });

            setIntervals(dataInterval.intervals);
        } catch (error: any) {
            console.log(error);
        }
    };

    useEffect(() => {
        getOffices();
        getAllCasas();
    }, []);

    return (
        <div className="absolute select-none">
            <Dialog defaultOpen={true} onOpenChange={() => setEdit(null)}>
                <DialogContent className="sm:max-w-[425px] select-none">
                    <DialogHeader>
                        <DialogTitle className="capitalize">
                            {" "}
                            {edit
                                ? ` ${dayjs(edit).format(
                                      "dddd"
                                  )} ${edit.toLocaleDateString()}`
                                : ""}
                        </DialogTitle>
                        <DialogDescription>
                            {step === 0
                                ? "Selecciona la opción que deseas realizar para este día"
                                : step === 2 && select === "bloquear"
                                ? "Si deseas bloquear este dia dale click en el botón guardar"
                                : step === 3 && select === "bloquear"
                                ? "Selecciona la hora que deseas bloquear"
                                : patientSelected && select === "agendar"
                                ? "Selecciona la hora que deseas agendar"
                                : "Selecciona el contacto que deseas agendar"}
                        </DialogDescription>
                    </DialogHeader>
                    {select === null && (
                        <div className="grid gap-4 py-4">
                            <div className="grid items-center grid-cols-4 gap-4 ">
                                <Button
                                    onClick={() => setSelect("bloquear")}
                                    type="button"
                                    className="w-full col-span-4 bg-red-400 select-none hover:bg-red-300 ">
                                    Bloquear Dia/Hora
                                </Button>
                            </div>

                            <div className="grid items-center grid-cols-4 gap-4">
                                <Button
                                    className="w-full col-span-4 text-white bg-[#029BFC]"
                                    onClick={() => (
                                        setSelect("agendar"), setStep(1)
                                    )}
                                    type="button">
                                    Agendar Turno
                                </Button>
                            </div>
                        </div>
                    )}

                    {select === "bloquear" && step === 0 && (
                        <div className="grid gap-4 py-4">
                            <div className="grid items-center grid-cols-4 gap-4">
                                <Button
                                    onClick={() => setStep(2)}
                                    type="button"
                                    className="w-full col-span-4 bg-[#029BFC] ">
                                    Bloquear Dia
                                </Button>
                            </div>

                            <div className="grid items-center grid-cols-4 gap-4 ">
                                <Button
                                    onClick={() => setStep(3)}
                                    type="button"
                                    className="w-full col-span-4 bg-[#029BFC]">
                                    Bloquear Hora
                                </Button>
                            </div>
                        </div>
                    )}
                    {select === "bloquear" && step === 3 && (
                        <div className="grid gap-4 py-4">
                            <div className="grid items-center grid-cols-4 gap-4">
                                <div className="col-span-4">
                                    <Label
                                        htmlFor="Carrera"
                                        className="text-right">
                                        Hora de inicio
                                    </Label>
                                </div>

                                <div className="col-span-4">
                                    <Select
                                        onValueChange={(value) =>
                                            setStartTime(value)
                                        }>
                                        <SelectTrigger
                                            translate="no"
                                            className="w-full">
                                            <SelectValue
                                                translate="no"
                                                placeholder="Selecciona la hora de inicio"
                                            />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup
                                                translate="no"
                                                className="pt-6 pb-14 xs400:pt-2 xs400:pb-10">
                                                {intervals.map(
                                                    (time, index) => (
                                                        <SelectItem
                                                            translate="no"
                                                            key={index}
                                                            value={
                                                                time.opening_time
                                                            }>
                                                            {time.opening_time}
                                                        </SelectItem>
                                                    )
                                                )}
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                            <div className="grid items-center grid-cols-4 gap-4">
                                <div className="col-span-4">
                                    <Label
                                        htmlFor="Carrera"
                                        className="text-right">
                                        Hora de fin
                                    </Label>
                                </div>

                                <div className="col-span-4">
                                    <Select
                                        onValueChange={(value) =>
                                            setEndTime(value)
                                        }>
                                        <SelectTrigger
                                            translate="no"
                                            className="w-full">
                                            <SelectValue
                                                translate="no"
                                                placeholder="Selecciona la hora de fin"
                                            />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup
                                                translate="no"
                                                className="py-6 xs400:py-2">
                                                {intervals.map(
                                                    (time, index) => (
                                                        <SelectItem
                                                            translate="no"
                                                            key={index}
                                                            value={
                                                                time.opening_time
                                                            }>
                                                            {time.opening_time}
                                                        </SelectItem>
                                                    )
                                                )}
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    )}
                    {select === "agendar" && patientSelected === null && (
                        <div className="grid gap-4 py-4">
                            <div className="grid items-center grid-cols-4 gap-4">
                                <Label className="col-span-3 xs400:col-span-2">
                                    Contacto
                                </Label>
                                <Button
                                    className="col-span-1 gap-2 px-6 text-xs xs400:col-span-2 bg-[#029BFC]"
                                    onClick={() => setDeleteShift(true)}
                                    type="submit">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round">
                                        {" "}
                                        <line
                                            x1="12"
                                            y1="5"
                                            x2="12"
                                            y2="19"
                                        />{" "}
                                        <line x1="5" y1="12" x2="19" y2="12" />
                                    </svg>{" "}
                                    <p className="hidden xs400:flex">
                                        {" "}
                                        Crear contacto
                                    </p>
                                </Button>
                                <div className="col-span-4">
                                    <DinamicSearchBar
                                        input={input}
                                        setInput={setInput}
                                        callbackFunction={getData}
                                    />
                                    <span className="mt-2 ml-2 text-xs text-blue-consulta-400">
                                        Busque por el nombre o apellido
                                    </span>
                                </div>
                            </div>
                            <div className="grid items-center grid-cols-4 gap-4">
                                <ScrollArea className="w-full h-48 col-span-4 border rounded-md">
                                    {patients.patient.map((patient) => (
                                        <div key={patient.id}>
                                            <div className="grid items-center grid-cols-4 gap-4 mt-2">
                                                <div className="col-span-4 mx-2">
                                                    <div
                                                        onClick={() =>
                                                            setPatientSelected(
                                                                patient
                                                            )
                                                        }
                                                        className="flex items-center gap-2 cursor-pointer ">
                                                        <img
                                                            src={`${process.env.REACT_APP_PROXY}/usuarios/getImage/${patient.avatar}`}
                                                            alt="avatar"
                                                            className="w-6 h-6 rounded-full"
                                                        />
                                                        <div className="ml-2">
                                                            <p className="font-semibold">
                                                                {patient.nombre}{" "}
                                                                {
                                                                    patient.apellido
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Separator className="my-2" />
                                        </div>
                                    ))}
                                </ScrollArea>
                            </div>
                        </div>
                    )}
                    {patientSelected && select === "agendar" && (
                        <div className="grid gap-4 py-4">
                            <div className="grid items-center grid-cols-4 gap-4">
                                <Label className="col-span-4">Contacto</Label>

                                <div className="flex items-center col-span-4 gap-2">
                                    <img
                                        src={`${process.env.REACT_APP_PROXY}/usuarios/getImage/${patientSelected.avatar}`}
                                        alt="avatar"
                                        className="w-10 h-10 rounded-full"
                                    />
                                    <Input
                                        disabled
                                        type="text"
                                        className="flex flex-col w-full "
                                        id="last_name"
                                        value={`${patientSelected.nombre} ${patientSelected.apellido}`}
                                    />
                                </div>
                            </div>

                            <div className="grid items-center grid-cols-4 gap-4">
                                {/* <div className="flex items-center justify-between col-span-4">
                                    <Label className="col-span-2">Hora </Label>
                                    <div className="flex items-center col-span-2 gap-2 text-sm font-medium leading-none top-10 right-4 font-poppins-regular peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                                        <p className="cursor-pointer">
                                            Turno recurrente
                                        </p>
                                        <Switch
                                            onClick={(e) => {
                                                setToggleButton(!toggleButton);
                                            }}
                                        />
                                    </div>
                                </div> */}
                                <div className="flex flex-col col-span-4 gap-4">
                                    <Select
                                        onValueChange={(value) =>
                                            setCasaSelected(Number(value))
                                        }>
                                        <SelectTrigger
                                            translate="no"
                                            className="w-full">
                                            <SelectValue
                                                translate="no"
                                                placeholder="Selecciona la propiedad"
                                            />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup
                                                translate="no"
                                                className="py-6 xs400:py-2">
                                                {casas.map((casa, index) => (
                                                    <SelectItem
                                                        translate="no"
                                                        key={index}
                                                        value={String(casa.id)}>
                                                        <div className="grid items-center grid-cols-4 gap-4 mt-2">
                                                            <div className="col-span-4 mx-2">
                                                                <div className="flex items-center gap-2 cursor-pointer ">
                                                                    <img
                                                                        src={`${process.env.REACT_APP_PROXY}/casa/getImage/${casa.banner}`}
                                                                        alt="avatar"
                                                                        className="w-6 h-6 rounded-full"
                                                                    />
                                                                    <div className="ml-2">
                                                                        <p className="font-semibold">
                                                                            {
                                                                                casa.nombre
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SelectItem>
                                                ))}
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                </div>
                                <div className="flex flex-col col-span-4 gap-4">
                                    <Select
                                        onValueChange={(value) =>
                                            setTimeOfTurn(value)
                                        }>
                                        <SelectTrigger
                                            translate="no"
                                            className="w-full">
                                            <SelectValue
                                                translate="no"
                                                placeholder="Selecciona la hora"
                                            />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup
                                                translate="no"
                                                className="py-6 xs400:py-2">
                                                {intervals.map(
                                                    (time, index) => (
                                                        <SelectItem
                                                            translate="no"
                                                            key={index}
                                                            value={
                                                                time.opening_time
                                                            }>
                                                            {time.opening_time}
                                                        </SelectItem>
                                                    )
                                                )}
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                    {toggleButton && (
                                        <>
                                            <Select
                                                onValueChange={(value) =>
                                                    setRecurrenceType(value)
                                                }>
                                                <SelectTrigger
                                                    translate="no"
                                                    className="w-full">
                                                    <SelectValue
                                                        translate="no"
                                                        placeholder="Seleccione la frecuencia"
                                                    />
                                                </SelectTrigger>
                                                <SelectContent>
                                                    <SelectItem
                                                        translate="no"
                                                        value="weekly">
                                                        Una vez a la semana
                                                        (cada{" "}
                                                        {dayjs(edit).format(
                                                            "dddd"
                                                        )}
                                                        )
                                                    </SelectItem>
                                                    <SelectItem
                                                        translate="no"
                                                        value="monthly">
                                                        Una vez al mes (cada 28
                                                        días)
                                                    </SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <Label className="col-span-2">
                                                Fecha final del turno recurrente
                                            </Label>
                                            <Input
                                                type="date"
                                                value={endDate}
                                                onChange={(e) =>
                                                    setEndDate(e.target.value)
                                                }
                                                className="w-full"
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    <DialogFooter className={select ? "" : "hidden"}>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                if (step === 0) {
                                    setSelect(null);
                                } else if (
                                    select === "agendar" &&
                                    patientSelected
                                ) {
                                    setPatientSelected(null);
                                } else if (select === "agendar" && step === 1) {
                                    setSelect(null);
                                    setStep(0);
                                } else {
                                    setStep(0);
                                }
                            }}
                            type="button"
                            className="">
                            Atrás
                        </Button>
                        {(step > 1 || patientSelected) && (
                            <Button
                                className="bg-[#029BFC]"
                                disabled={loading}
                                onClick={() => handleSubmit()}
                                type="submit">
                                {loading ? (
                                    <>
                                        <ReloadIcon className="w-4 h-4 mr-2 animate-spin" />
                                        Cargando
                                    </>
                                ) : (
                                    "Guardar"
                                )}
                            </Button>
                        )}
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            <AlertDialog
                open={deleteShift}
                onOpenChange={() => setDeleteShift(!edit)}>
                <AlertDialogContent className="pb-12">
                    <AlertDialogHeader>
                        <AlertDialogTitle>Nuevo contacto</AlertDialogTitle>
                        <AlertDialogDescription>
                            ¿Desea crear un nuevo contacto?
                        </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogDescription>
                        <div className="grid items-center grid-cols-4 gap-4 mt-2">
                            <div className="col-span-4">
                                {" "}
                                <Label htmlFor="Carrera" className="text-right">
                                    Nombre
                                </Label>
                            </div>

                            <div className="col-span-4 -mt-3">
                                {" "}
                                <Input
                                    onChange={handleChange}
                                    type="text"
                                    className="flex flex-col w-full "
                                    id="firstName"
                                    name="firstName"
                                    value={newPatient.firstName}
                                />
                            </div>
                        </div>
                        <div className="grid items-center grid-cols-4 gap-4 mt-2">
                            <div className="col-span-4">
                                {" "}
                                <Label htmlFor="Carrera" className="text-right">
                                    Apellido
                                </Label>
                            </div>

                            <div className="col-span-4 -mt-3">
                                {" "}
                                <Input
                                    onChange={handleChange}
                                    type="text"
                                    className="flex flex-col w-full "
                                    id="lastName"
                                    name="lastName"
                                    value={newPatient.lastName}
                                />
                            </div>
                        </div>
                        <div className="grid items-center grid-cols-4 gap-4 mt-2">
                            <div className="col-span-4">
                                {" "}
                                <Label htmlFor="Carrera" className="text-right">
                                    Teléfono
                                </Label>
                            </div>

                            <div className="col-span-4 -mt-3">
                                {" "}
                                <Input
                                    onChange={handleChange}
                                    type="text"
                                    className="flex flex-col w-full "
                                    id="phone"
                                    name="phone"
                                    value={newPatient.phone}
                                />
                            </div>
                        </div>
                        <div className="grid items-center grid-cols-4 gap-4 mt-2">
                            <div className="col-span-4">
                                {" "}
                                <Label htmlFor="Carrera" className="text-right">
                                    Correo
                                </Label>
                            </div>

                            <div className="col-span-4 -mt-3">
                                {" "}
                                <Input
                                    onChange={handleChange}
                                    type="text"
                                    className="flex flex-col w-full "
                                    id="email"
                                    name="email"
                                    value={newPatient.email}
                                />
                            </div>
                        </div>
                    </AlertDialogDescription>
                    <AlertDialogFooter>
                        <AlertDialogCancel
                            className="cancel-button"
                            onClick={() => (
                                setDeleteShift(!edit),
                                setNewPatient(INITIAL_STATE),
                                setSelectedFile({
                                    img: null,
                                    type: "",
                                }),
                                setAvatar("")
                            )}>
                            Atrás
                        </AlertDialogCancel>
                        <Button
                            disabled={loadingPatient}
                            type="submit"
                            onClick={() => handleSubmitPatient()}
                            className="bg-[#029BFC]">
                            {loadingPatient ? (
                                <>
                                    <ReloadIcon className="w-4 h-4 mr-2 animate-spin" />
                                    Creando
                                </>
                            ) : (
                                "Crear Contacto"
                            )}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </div>
    );
};
